import { gql } from '@apollo/client';

const GET_LARGE_SCREEN_NAV_CATEGORIES = gql`
  query CategorySubcategories($categoryId: String!, $skipCache: Boolean, $storePreview: String) {
    navigationCategory(categoryId: $categoryId, skipCache: $skipCache, storePreview: $storePreview) {
      brand
      brandLabel
      categoryId
      mainNavLogoData {
        tagType
        largeScreen
        largeScreen2x
        largeScreenPoster
      }
      brandLogoType
      url
      hasSpecialNavInteraction
      navigationSubCategories(cacheEmpty: false, hideCategory: false) {
        categoryId
        espotIdentifier
        isFullWidthFlyout
        name
        url
        topNavEspotContent {
          espotId
          htmlContent
          timestamp
        }
        navigationSubCategories(displayTypes: ["regular", "clearance", "featured"], expandByDisplayTypes: ["regular"]) {
          categoryId
          displayType
          name
          url
          navigationSubCategories {
            categoryId
            name
            url
          }
        }
      }
    }
  }
`;

export default GET_LARGE_SCREEN_NAV_CATEGORIES;
